import Request from '@hotmart/request'
import { REQUEST_SECURITY } from './auth.constants'

Request.register(`${process.env.API_SECURITY}/security/oauth`, {
  get: {
    [REQUEST_SECURITY.LOGOUT]: '/logout',
    [REQUEST_SECURITY.CHECK_TOKEN]: '/check_token?token=:access_token'
  },
  post: {
    [REQUEST_SECURITY.LOGIN]: '/token?grant_type=password'
  }
})

Request.register(`${process.env.API_SECURITY}/security/rest/v1/user`, {
  put: {
    [REQUEST_SECURITY.ADD_SIGNUP_ROLE]: '/:userId/role/platform/signup'
  }
})

export const checkToken = (token: string) => new Request(REQUEST_SECURITY.CHECK_TOKEN, { access_token: token })
